import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AdminDiscounts() {
  const [discounts, setDiscounts] = useState([]);
  const [form, setForm] = useState({ code: "", type: "percentage", value: 10, min_subtotal_inr: 0, active: true });

  const load = async () => {
    const { data } = await api.get("/admin/discounts");
    setDiscounts(data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/discounts", { ...form, value: parseFloat(form.value), min_subtotal_inr: parseFloat(form.min_subtotal_inr) });
      toast.success("Discount added.");
      setForm({ code: "", type: "percentage", value: 10, min_subtotal_inr: 0, active: true });
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed."); }
  };

  const del = async (id) => {
    if (!confirm("Delete this code?")) return;
    await api.delete(`/admin/discounts/${id}`);
    load();
  };

  return (
    <div data-testid="admin-discounts">
      <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Promotions</p>
      <h1 className="font-serif text-4xl mb-8">Discount Codes</h1>

      <form onSubmit={submit} className="bg-white p-6 border border-black/5 mb-8 grid md:grid-cols-6 gap-4 items-end">
        <label className="block md:col-span-2"><span className="text-[11px] uppercase tracking-nav">Code</span>
          <input required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="w-full border border-black/10 px-3 py-2 font-mono-alt" data-testid="admin-disc-code" /></label>
        <label className="block"><span className="text-[11px] uppercase tracking-nav">Type</span>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full border border-black/10 px-3 py-2">
            <option value="percentage">Percentage</option><option value="fixed">Fixed</option>
          </select></label>
        <label className="block"><span className="text-[11px] uppercase tracking-nav">Value</span>
          <input required type="number" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} className="w-full border border-black/10 px-3 py-2" /></label>
        <label className="block"><span className="text-[11px] uppercase tracking-nav">Min subtotal (INR)</span>
          <input type="number" value={form.min_subtotal_inr} onChange={(e) => setForm({ ...form, min_subtotal_inr: e.target.value })} className="w-full border border-black/10 px-3 py-2" /></label>
        <button className="bg-[#5C1A1B] text-white uppercase tracking-nav text-[11px] py-2" data-testid="admin-disc-add">Add code</button>
      </form>

      <div className="bg-white border border-black/5">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-nav text-[#7A7A7A] border-b border-black/5">
            <tr><th className="px-4 py-3">Code</th><th className="px-4 py-3">Type</th><th className="px-4 py-3">Value</th><th className="px-4 py-3">Min INR</th><th className="px-4 py-3">Active</th><th className="px-4 py-3"></th></tr>
          </thead>
          <tbody>
            {discounts.map((d) => (
              <tr key={d.discount_id} className="border-b border-black/5" data-testid={`admin-disc-row-${d.code}`}>
                <td className="px-4 py-3 font-mono-alt">{d.code}</td>
                <td className="px-4 py-3">{d.type}</td>
                <td className="px-4 py-3">{d.type === "percentage" ? `${d.value}%` : `₹${d.value}`}</td>
                <td className="px-4 py-3">₹{d.min_subtotal_inr}</td>
                <td className="px-4 py-3">{d.active ? "Yes" : "—"}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(d.discount_id)} className="text-[#D32F2F] text-[11px] uppercase tracking-nav" data-testid={`admin-disc-del-${d.code}`}><Trash2 size={12} className="inline" /> Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
